// extracted by mini-css-extract-plugin
export default {"body":"App_body__f+ezj","sizeWarning":"App_sizeWarning__bQHbI"};